const CAROUSEL_ITEMS = [
  {
    id: 1,
    tag: '热门推荐',
    title: '香蕉视频 · 高分影视合集',
    desc: '精选香蕉视频平台近一周评分最高的电影与剧集，涵盖动作、悬疑、爱情等多种类型，片荒必刷。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20golden%20yellow%20tropical%20fruit%20still%20life%20with%20bananas%20on%20soft%20beige%20background%2C%20minimalist%20editorial%20photography%20with%20gentle%20shadows%20and%20warm%20natural%20lighting%2C%20clean%20composition%2C%20modern%20flat%20lay%20style&width=800&height=500&seq=carousel-item-01&orientation=landscape',
    alt: '香蕉视频高分影视合集',
    stat: '本周更新 32 部',
  },
  {
    id: 2,
    tag: '免费专区',
    title: '西瓜视频免费 · 经典重温',
    desc: '西瓜视频免费专区经典影视作品大赏，从老港片到国产剧，无需会员随时畅享。',
    img: 'https://readdy.ai/api/search-image?query=Fresh%20watermelon%20slices%20arranged%20artistically%20on%20light%20cream%20surface%2C%20summer%20vibe%20with%20soft%20sunlight%20and%20green%20leaves%2C%20bright%20refreshing%20color%20palette%20of%20red%20and%20green%2C%20clean%20minimal%20photography%20style&width=800&height=500&seq=carousel-item-02&orientation=landscape',
    alt: '西瓜视频免费经典重温',
    stat: '经典片库 2000+ 部',
  },
  {
    id: 3,
    tag: '新片速递',
    title: '蜜桃视频 · 最新日韩剧集',
    desc: '蜜桃视频持续引进热门日韩新剧，同步更新中文字幕版，追剧党不可错过的首选平台。',
    img: 'https://readdy.ai/api/search-image?query=Ripe%20peaches%20with%20soft%20pink%20and%20cream%20tones%20on%20delicate%20fabric%20background%2C%20romantic%20warm%20atmosphere%20with%20diffused%20natural%20light%2C%20elegant%20still%20life%20photography%2C%20gentle%20shadows%20and%20pastel%20aesthetic&width=800&height=500&seq=carousel-item-03&orientation=landscape',
    alt: '蜜桃视频最新日韩剧集',
    stat: '本月上新 56 部',
  },
  {
    id: 4,
    tag: '浪漫剧场',
    title: '樱花视频 · 纯爱治愈特辑',
    desc: '樱花视频精选清新治愈系影视作品，日系纯爱、青春校园、温馨家庭，抚慰你的每一个夜晚。',
    img: 'https://readdy.ai/api/search-image?query=Delicate%20cherry%20blossoms%20in%20soft%20pink%20on%20branches%20against%20gentle%20cream%20sky%2C%20dreamy%20spring%20atmosphere%20with%20floating%20petals%2C%20soft%20focus%20photography%20with%20warm%20pastel%20tones%2C%20romantic%20and%20airy%20composition&width=800&height=500&seq=carousel-item-04&orientation=landscape',
    alt: '樱花视频纯爱治愈特辑',
    stat: '治愈片单 180+ 部',
  },
  {
    id: 5,
    tag: '人气综艺',
    title: '水果视频在线 · 爆笑综艺合集',
    desc: '水果视频在线平台最受欢迎的综艺节目一次收录，真人秀、脱口秀、美食探店精彩不停。',
    img: 'https://readdy.ai/api/search-image?query=Colorful%20assorted%20fruits%20arranged%20in%20playful%20pattern%20on%20light%20wooden%20surface%2C%20bright%20vibrant%20colors%20of%20orange%20lemon%20berry%20and%20kiwi%2C%20cheerful%20flat%20lay%20photography%20with%20natural%20sunlight%2C%20fresh%20and%20energetic%20mood&width=800&height=500&seq=carousel-item-05&orientation=landscape',
    alt: '水果视频在线爆笑综艺合集',
    stat: '综艺库存 600+ 档',
  },
  {
    id: 6,
    tag: '纪录片',
    title: '植物视频平台 · 自然万象',
    desc: '植物视频平台精选自然与人文纪录片，从雨林生态到极地风光，足不出户看世界奇观。',
    img: 'https://readdy.ai/api/search-image?query=Lush%20green%20tropical%20foliage%20with%20various%20plant%20leaves%20in%20rich%20emerald%20tones%2C%20soft%20morning%20light%20filtering%20through%20the%20canopy%2C%20botanical%20garden%20atmosphere%2C%20serene%20and%20natural%20photography%20with%20deep%20green%20color%20palette&width=800&height=500&seq=carousel-item-06&orientation=landscape',
    alt: '植物视频平台自然万象纪录片',
    stat: '纪录片库 320+ 部',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">
              精选专题
            </h2>
            <p className="text-sm text-foreground-500">每日更新优质视频平台精选合集，发现你的下一部心头好</p>
          </div>
          <span className="hidden sm:flex items-center gap-1.5 text-sm text-primary-600 font-medium cursor-pointer whitespace-nowrap">
            查看全部 <i className="ri-arrow-right-line"></i>
          </span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {CAROUSEL_ITEMS.map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={item.img}
                  alt={item.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    if (target.parentElement) {
                      target.parentElement.classList.add('bg-background-200');
                    }
                  }}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-medium">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-bold font-heading text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                  {item.desc}
                </p>
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <i className="ri-time-line"></i>
                  <span>{item.stat}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}